import React from 'react';

import { utils } from 'components/lexemes';

import { Header1, Header2, Header3 } from 'components/typography';

enum TitleAnchorElementType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  NONE = '',
}

type TitleAnchorProps = {
  id: string;
  title: string;
  titleAnchorElement?: TitleAnchorElementType;
};

const mapTitleAnchorElementTypeToContentWrapper: {
  [key in TitleAnchorElementType]: React.FC | undefined;
} = {
  [TitleAnchorElementType.H1]: Header1,
  [TitleAnchorElementType.H2]: Header2,
  [TitleAnchorElementType.H3]: Header3,
  [TitleAnchorElementType.NONE]: undefined,
};

export function TitleAnchor({
  id,
  title,
  titleAnchorElement = TitleAnchorElementType.H2,
}: TitleAnchorProps) {
  const Element: React.ElementType | undefined =
    mapTitleAnchorElementTypeToContentWrapper[titleAnchorElement];
  return (
    <div className="navigation-block" id={id}>
      {Element ? (
        <Element>
          <utils.dangerousHtmlStringWrapper input={title} />
        </Element>
      ) : (
        <utils.dangerousHtmlStringWrapper input={title} />
      )}
    </div>
  );
}
TitleAnchor.ElementType = TitleAnchorElementType;
